import { ApiBaseService, ApiV2Service } from './api.base.service';
import {DeviceVersion, DeviceVersionRule, IdResponse, JSONRule, RuleConditions, SuccessResponse} from '@/types';

export class RulesService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApiV2Service;
  }

  public async getDevice(id: number): Promise<DeviceVersion> {
    return this.api.get(`admin/deviceVersions/${id}`);
  }

  public async getDeviceRules(id: number): Promise<DeviceVersionRule[]> {
    return this.api.get(`admin/deviceVersion/${id}/rules`);
  }

  public async createRule(id: number, body: DeviceVersionRule): Promise<IdResponse> {
    return this.api.post(`admin/deviceVersion/${id}/rule`, body);
  }

  public async updateRule(id: number, body: DeviceVersionRule): Promise<IdResponse> {
    return this.api.put(`admin/deviceVersion/rule/${id}`, body);
  }

  public async deleteRule(id: number): Promise<SuccessResponse> {
    return this.api.delete(`admin/deviceVersion/rule/${id}`);
  }
}

export default new RulesService();
